import CachedIcon from "mdi-react/CachedIcon";
import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Dropdown } from "react-bootstrap";
import TableComponent from "../TableComponent";
import {
  Checked,
  CustomerAccountSelectIcon,
  DownloadIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  LoaderIcon,
  ViewIcon,
} from "../Icons";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { format } from "date-fns";
import queryString from "query-string";
import { formatDate, paginationOptions } from "../../utils/helpers";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ReactPaginate from "react-paginate";
import NoTableItem from "../utils/NoTableItem";
import { isEmpty, truncate } from "lodash";
import { useNavigate, useOutletContext } from "react-router-dom";
import PartnerDetails from "./PartnerDetails";
import PrincingModal from "./PrincingModal";
import DocumentUpload from "./DocumentUpload";
import ConfirmDialog from "../ConfirmDialogue";
import { toast } from "react-toastify";

export default function EBCompanyList() {
  const refetchNav = useOutletContext();
  const { backendUrl, token } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage(
    "showEBCompanyFilter",
    true
  );

  const [showCompanyBranchModal, setShowCompanyModal] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [multiSelectionMode, setMultiSelectionMode] = useState(false);
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState(null);
  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const { user } = useAuth();
  const initialFilterParams = {
    companyName: "",
    startDate: "",
    endDate: "",
    companyID: "",
  };
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const [multiSelected, setMultiSelected] = useState([]);

  const fetchInvexPartners = async (query) => {
    const res = await fetch(
      `${backendUrl}/api/partnership/invexerp-partners?${queryString.stringify(
        query
      )}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    if (!res.ok) {
      toast.error("unable to get partners")
      return []
    }
    const data = await res.json();

    return data;
  };

  const updateInvexPartner = async (payload) => {
    try {
      console.log(payload);
      const res = await fetch(
        `${backendUrl}/api/partnership/invexerp-partner`,
        {
          method: "PUT",
          credentials: "include",
          body: JSON.stringify(payload),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );

      if (!res.ok) throw new Error(`Error: ${res.status} ${res.statusText}`);
      refetchNav.refetch();
      return await res.json(); // Parse response as JSON
    } catch (error) {
      console.error("Update failed:", error);
      throw error;
    }
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_INVEX_PARTNERS", queryParams],
    () => fetchInvexPartners(queryParams),

    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    setPartnerList(data);
  }, [data]);

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const handleFilterParamsChange = (e) => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(
        ({
          company_name,
          company_email,
          first_name,
          last_name,
          personal_email,
        }) => {
          return (
            company_name.toLowerCase().includes(searchValue) ||
            company_email.toLowerCase().includes(searchValue) ||
            first_name.toLowerCase().includes(searchValue) ||
            last_name.toLowerCase().includes(searchValue) ||
            personal_email.toLowerCase().includes(searchValue)
          );
        }
      )
    );
  };
  const handleLocationChange = (e) => {
    let searchValue = e.target.value?.toLowerCase();
    setPartnerList(() =>
      data.filter(({ country, state, city }) => {
        return (
          country.toLowerCase().includes(searchValue) ||
          state.toLowerCase().includes(searchValue) ||
          city.toLowerCase().includes(searchValue)
        );
      })
    );
  };
  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const allSelected = multiSelected.length === data?.length;
  const handleCheckboxChange = (id) => {
    setMultiSelected(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((item) => item !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const handleVerify = async (partner) => {
    try {
      if (
        await ConfirmDialog({
          description: `Are you sure you want to ${
            partner?.is_verified ? "unverify" : "verify"
          } ${
            partner
              ? "this partner"
              : "all (" + multiSelected.length + ") partners"
          }`,
        })
      ) {
        setIsLoading(true);
        if (partner !== undefined) {
          let payload = {
            id: [partner.id],
            action: { is_verified: !Boolean(partner.is_verified) },
          };
          await updateInvexPartner(payload);
        } else {
          let payload = { id: multiSelected };
          await updateInvexPartner(payload);
        }
      }
    } catch (error) {
      console.error("Error verifying:", error);
    } finally {
      await refetch();
      setMultiSelectionMode(false);
      setIsLoading(false);
    }
  };

  const fetchPartnerDashboardLink = async (partner) => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${backendUrl}/api/partnership/admin-auth-link/${user.Staff_ID}/${
          partner.id
        }`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
      if (!res.ok) throw new Error(`Error: ${res.message}`);
      const data = await res.json();
      if (data.token) {
        // redirect to the dashboard link
        window.open(
          `https://partners.invex.com/dashboard?token=${data.token}`,
          "_blank"
        );
      } else {
        // show error message
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching dashboard link:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          {multiSelectionMode && (
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) => {
                  setMultiSelected(
                    allSelected ? [] : data?.map((item) => item.id)
                  );
                }}
              />
            </th>
          )}
          <th>
            <Button
              variant="white"
              onClick={() => {
                setMultiSelected(data?.map((item) => item.id));
                setMultiSelectionMode((prev) => !prev);
              }}
            >
              {" "}
              {/* <SettingsIcon color="white" /> */}
              {multiSelectionMode ? "Cancel" : "Select all"}
            </Button>
          </th>
          {/* <th>Company ID</th> */}

          <th>Company name</th>
          <th>Company email</th>
          <th>Personal email</th>

          <th>Country</th>
          <th>State</th>
          <th>City</th>

          <th>First Name</th>
          <th>Last Name</th>

          <th>Date Registered</th>
          <th>Approved</th>
        </tr>
      </thead>
    );
  };

  const getStatus = (date) => {
    const currentDate = new Date().getTime();
    let expiringDate = new Date(date);
    expiringDate.setDate(expiringDate.getDate() - 9);

    expiringDate = new Date(expiringDate).getTime();

    let timeDiff = currentDate - expiringDate;

    let daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

    let status;

    if (daysDiff > 9) {
      status = "Suspended";
    } else {
      status = currentDate > expiringDate ? "Expired" : "Active";
    }

    return status;
  };

  function getExpiringDate(date) {
    let expDate = new Date(date);

    expDate.setDate(expDate.getDate() - 9);

    return expDate;
  }

  const tableData = (el, index) => {
    return (
      <>
        {multiSelectionMode && (
          <td>
            <input
              type="checkbox"
              checked={multiSelected.includes(el.id)}
              onChange={() => {
                handleCheckboxChange(el.id);
              }}
            />
          </td>
        )}
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowCompanyModal(true);
                }}
              >
                <ViewIcon /> View partner
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  handleVerify(el);

                  // setShowEmailAddressModal(true);
                }}
              >
                <Checked color="#94A3B8" />
                {el.is_verified ? "Unverify partner" : "Verify partner"}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setSelectedPartnerDetails(el);
                  setShowDocumentUploadModal(true);
                }}
              >
                <DownloadIcon />
                Upload docs{" "}
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  fetchPartnerDashboardLink(el);
                }}
              >
                <CustomerAccountSelectIcon />
                Goto dashboard
              </Dropdown.Item>
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>

        {/* <td>{el?.companyID}</td> */}
        <td>{el?.company_name}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.company_email}</td>
        <td style={{ wordBreak: "break-all" }}>{el?.personal_email}</td>
        <td>{el?.country}</td>
        <td>{el?.state}</td>
        <td>{el?.city}</td>
        <td>{el?.first_name}</td>
        <td>{el?.last_name}</td>

        <td>
          {el?.createdAt ? (
            <>
              <div>{`${formatDate(
                new Date(el?.createdAt),
                "dd MMM, yyyy"
              )}`}</div>
              <div
                className=""
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                {`${formatDate(new Date(el?.createdAt), "hh:mm a")}`}
              </div>
              <div>
                {truncate(el?.lastSeenBranch, {
                  length: 15,
                })}
              </div>
            </>
          ) : (
            "..."
          )}
        </td>
        {/* 
        <td>
          {!isNaN(new Date(el?.companyDateCreated).getTime())
            ? format(new Date(el?.companyDateCreated), "dd MMM, yyyy")
            : "..........."}
        </td>
        <td>
          {!isNaN(new Date(el?.companyExpiringDate).getTime())
            ? format(new Date(el?.companyExpiringDate), "dd MMM, yyyy")
            : "............"}
        </td> */}
        <td
          className={`
             "expiring-date-color  fw-bold"
            ${el?.is_verified ? "text-success fw-bold" : "text-danger fw-bold"}
          `}
          style={{ textTransform: "capitalize" }}
        >
          {String(Boolean(el?.is_verified))}
        </td>
      </>
    );
  };

  return (
    <>
      {/* {scheduleMaintenance && (
        <ScheduleMaintenance
          showCompanyBranchModal={scheduleMaintenance}
          companyID={companyId}
          setShowCompanyModal={setShecduleMaintenance}
          companyName={EBCompanyName}
          isSpecificCompany={true}
        />
      )} */}
      {/* {showCreateCompanyModal && (
        <CreateCompanyMondal
          setShowCreateCompanyModal={setShowCreateCompanyModal}
          showCreateCompanyModal={showCreateCompanyModal}
          updateCompanyModal={updateCompanyModal}
          refetch={refetch}
          companyID={companyId}
          companyName={EBCompanyName}
        />
      )} */}

      {showCompanyBranchModal && (
        <PartnerDetails
          data={selectedPartnerDetails}
          setShow={setShowCompanyModal}
        />
      )}

      {showDocumentUploadModal && (
        <DocumentUpload
          refetch={refetch}
          setShow={setShowDocumentUploadModal}
          partner={selectedPartnerDetails}
        />
      )}

      <main className="cash-book ">
        <div className="content ">
          <div className="content-main pt-3">
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <h2>
                  <FilterTwoIcon /> Filters
                </h2>

                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body">
                <Form>
                  <div className="body">
                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Campany Name</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="companyName"
                          // value={filterParams?.companyName}
                          placeholder="Enter company name"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Location</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="location"
                          // value={filterParams.companyID}
                          placeholder="Enter country, state or city"
                          onChange={(e) => handleLocationChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group>

                    {/* <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Branch</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="branch"
                          value={filterParams.branch}
                          placeholder="branch name"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group> */}

                    <hr className="mt-3 mb-4" />
                    {/* <Form.Group className="">
                      <Form.Label>Date Range</Form.Label>
                      <div className="position-relative">
                        <RsDateRangePicker
                          placement="topStart"
                          value={
                            filterParams.startDate && filterParams.endDate
                              ? [
                                  parse(
                                    filterParams.startDate,
                                    "yyyy-MM-dd",
                                    new Date()
                                  ),
                                  parse(
                                    filterParams.endDate,
                                    "yyyy-MM-dd",
                                    new Date()
                                  ),
                                ]
                              : []
                          }
                          onClean={() => clearDateRange()}
                          onOk={(date) => filterByDateRange(date)}
                        />
                      </div>
                    </Form.Group> */}
                  </div>

                  {/* <div className="buttons rounded">
                    <Button onClick={() => reset()} variant="white">
                      Reset
                    </Button>
                    <Button onClick={() => search()} variant="primary">
                      Search
                    </Button>
                  </div> */}
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon />
                    </button>
                  )}
                  Partner List
                  <button
                    title="Refresh"
                    className="btn text-primary"
                    onClick={() => {
                      refetch();
                      refetchNav.refetch();
                    }}
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div className="actions">
                  {multiSelectionMode && (
                    <Button
                      disabled={!Boolean(multiSelected.length)}
                      variant="primary"
                      onClick={() => {
                        multiSelected.length && handleVerify();
                      }}
                    >
                      Approve selected
                    </Button>
                  )}
                </div>
              </header>

              <div className="m-3">
                <TableComponent
                  responsive
                  borderless
                  striped
                  tableHeadsFunction={tableHead}
                  mainDataArray={partnerList || []}
                  className="product-table text-nowrap"
                  tableDataRowFunction={tableData}
                  // tableRowClick={(e, el) => manageTransaction(e, el)}
                />

                {!isFetching && isSuccess && isEmpty(data) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={(e) => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>{" "}
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data?.data?.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      {isLoading && (
        <div className="global-spinner">
          <LoaderIcon className="spin text-primary" />
        </div>
      )}
    </>
  );
}
